import React, { useState, useEffect } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Switch,
  FormControlLabel,
  Box,
  IconButton,
  Tooltip,
} from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import api from "../../../conf/api.js";
import { toast } from "react-toastify";

const FeedLockDialog = ({ open, setOpen, feed, onSuccess }) => {
  const [isPrivate, setIsPrivate] = useState(feed?.is_private);
  const [token, setToken] = useState("");
  const [loading, setLoading] = useState(false);

  const handleClose = () => setOpen(false);

  const handleAction = async () => {
    setLoading(true);
    // If currently private → remove auth (make public). If public → generate token (make private).
    const newStatus = isPrivate ? "public" : "private";
    api
      .post("/auth/feed-token/generate/", {
        feed_id: feed?.id,
        status: newStatus,
      })
      .then((res) => {
        if (newStatus === "private") {
          setToken(res.data.token);
          setIsPrivate(true);
        } else {
          setToken("");
          setIsPrivate(false);
          toast.success("Authentication removed. Feed is now public.");
        }
        onSuccess?.();
      })
      .catch((err) => {
        toast.error(err?.response?.data?.error || "Something went wrong");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const feedUrl = `${process.env.REACT_APP_BASE_URL}/mrss/feed/${feed?.xml_url}/?token=${token}`;

  const copyToken = () => {
    navigator.clipboard.writeText(feedUrl);
    toast.success("Feed URL copied to clipboard");
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>Feed ({feed?.title}) Security</DialogTitle>

      <DialogContent>
        <Box mt={1}>
          {isPrivate && token && (
            <Box>
              <label
                style={{ display: "block", marginBottom: 6, fontWeight: 500 }}
              >
                Feed URL with Token:
              </label>
              <Box
                display="flex"
                alignItems="center"
                sx={{ bgcolor: "grey.100", borderRadius: 1, p: 1 }}
              >
                <Box
                  component="span"
                  sx={{
                    color: "error.main",
                    fontWeight: 600,
                    fontSize: "0.8rem",
                    wordBreak: "break-all",
                    flex: 1,
                  }}
                >
                  {feedUrl}
                </Box>
                <Tooltip title="Copy URL">
                  <IconButton onClick={copyToken} size="small" sx={{ ml: 1 }}>
                    <ContentCopyIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              </Box>
            </Box>
          )}
        </Box>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose}>Close</Button>
        <Button
          variant="contained"
          onClick={handleAction}
          disabled={loading}
          color={isPrivate ? "error" : "primary"}
        >
          {isPrivate ? "Remove Authentication" : "Generate Token"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FeedLockDialog;
